import { WizardSubmitHandler }       from './WizardSubmitHandler'
import { WizardPrevHandler }         from './WizardPrevHandler'
import { ShowWizardSection }         from './ShowWizardSection'
import { UpdateBusinessHoursTime }   from './UpdateBusinessHoursTime'
import { Base64Encoded }             from './Base64Encoded'

import { InitWizardDomElements }             from './init/InitWizardDomElements'
import { InitLocationDomElements }           from './init/InitLocationDomElements'
import { InitResourceDomElements }           from './init/InitResourceDomElements'
import { InitServiceDomElements }            from './init/InitServiceDomElements'
import { InitAllocationDomElements,
         InitResourceAllocationDomElements } from './init/InitAllocationDomElements'
import { InitSelectDomElements, 
         InitTimezoneSelect }                from './init/InitSelectDomElements'


export const OnSchedWizardHelpers = {
  WizardSubmitHandler,
  WizardPrevHandler,
  ShowWizardSection,
  UpdateBusinessHoursTime,
  InitWizardDomElements,
  InitLocationDomElements,
  InitResourceDomElements,
  InitServiceDomElements,
  InitSelectDomElements,
  InitTimezoneSelect,
  InitAllocationDomElements,
  InitResourceAllocationDomElements,
  Base64Encoded,
}
